export class BaseList {
    rows: any[];
    count: number
    constructor() {

    }
}